'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = require('react');

var cleanElement = function cleanElement(Component) {
  return function (_React$Component) {
    (0, _inherits3.default)(Cleaned, _React$Component);

    function Cleaned() {
      (0, _classCallCheck3.default)(this, Cleaned);
      return (0, _possibleConstructorReturn3.default)(this, (Cleaned.__proto__ || (0, _getPrototypeOf2.default)(Cleaned)).apply(this, arguments));
    }

    (0, _createClass3.default)(Cleaned, [{
      key: 'render',
      value: function render() {
        var next = {};
        var keys = (0, _keys2.default)(Cleaned.propTypes || {});
        for (var key in this.props) {
          if (keys.includes(key)) continue;
          next[key] = this.props[key];
        }

        return React.createElement(Component, next);
      }
    }]);
    return Cleaned;
  }(React.Component);
};

module.exports = cleanElement;


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/clean-element.js
// module id = 371
// module chunks = 168707334958949